import { throttle } from "lodash";
import React, { useCallback, useEffect, useMemo, useRef } from "react";
import styles from "./style.module.scss";

interface INav {
  curActive: string;
  switchTab: (key: string) => void;
  tabs: { keyName: string; name: string }[];
  handleEleVisible?: () => void;
  handleEleUnVisible?: () => void;
}

const Nav: React.FC<INav> = ({
  curActive,
  switchTab,
  tabs,
  handleEleVisible,
  handleEleUnVisible,
}) => {
  const tabsDom = useRef<any>(null);
  useEffect(() => {
    window.addEventListener("scroll", scrollHandle, true);
    return () => window.removeEventListener("scroll", scrollHandle, true);
  });

  const scrollHandle = useCallback(
    throttle((e: any) => {
      const offset = tabsDom.current.getBoundingClientRect();
      const offsetTop = offset.top;
      const offsetBottom = offset.bottom;
      if (offsetTop <= window.innerHeight && offsetBottom >= 0) {
        handleEleVisible?.();
      } else {
        handleEleUnVisible?.();
      }
    }, 500),
    [],
  );

  return (
    <div className={styles["tabs-wrapper"]} ref={tabsDom}>
      {tabs.map((tab, key) => (
        <button
          onClick={() => switchTab(tab.keyName)}
          key={key}
          className={`${styles["tab-btn"]} ${
            curActive === tab.keyName && styles["tab-active-btn"]
          }`}
        >
          {tab.name}
        </button>
      ))}
    </div>
  );
};

export default Nav;
